import React from "react";
import clsx from "clsx";
import { SnippetButtonCol } from "./style/styledComponents";
import { useTheme, Typography, Grid, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  snippet: {
    borderBottom: "1px solid rgba(234, 234, 234, 0.5)",
    width: "inherit",
    padding: "10px 0px",
    backgroundColor: theme.palette.background.main,
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: theme.palette.background.hover,
      borderRadius: "5px",
      /* border: 1px solid rgba(234, 234, 234, 0.5), */
      cursor: "grab",
    },
    "&:active": {
      border: "none",
    },
  },
  snippetDragging: {
    borderBottom: `1px solid ${theme.palette.border.main}`,
    width: "inherit",
    padding: "10px 0px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "5px",
    color: `${theme.palette.primary.contrastText} !important`,
  },
  snippetSave: {
    borderBottom: "1px solid rgba(234, 234, 234, 0.5)",
    width: "inherit",
    padding: "10px 0px",
    backgroundColor: theme.palette.background.hover,
    borderRadius: "5px",
    fontStyle: "italic",
    " & i": {
      color: `${theme.palette.primary.main} !important`,
    },
  },
}));

export const Snippet = ({
  snippet,
  source,
  handleSave,
  article,
  isDragging,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const isSaved = article.snippets.some(
    (articleSnippet) => articleSnippet.text === snippet.text
  );

  const save = () => {
    if (!isSaved) handleSave({ ...snippet, source }, article.id);
  };

  const icon = isSaved ? "fa fa-bookmark" : "fa fa-bookmark-o";

  return (
    <Grid
      container
      className={clsx(
        { [classes.snippetSave]: isSaved },
        {
          [classes.snippetDragging]: isDragging,
          [classes.snippet]: !isDragging,
        }
      )}
    >
      <Grid item lg={11}>
        <Typography color="inherit">{snippet.text}</Typography>
      </Grid>
      {isDragging || !article.id ? null : (
        <SnippetButtonCol item lg={1} theme={theme}>
          <div onClick={() => save()}>
            <i className={icon} aria-hidden="true"></i>
          </div>
        </SnippetButtonCol>
      )}
    </Grid>
  );
};
